import { equal } from '@ember/object/computed';
import { attr } from '@ember-data/model';
import { isIn } from '@square/dashboard-utilities/macros';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import AudienceNatures from '@square/dashboard-data/models/marketing/audience-natures';
import AudiencePresetGroupType from '@square/dashboard-data/models/marketing/audience-preset-group-type';
import lowercaseEnum from '@square/dashboard-data/models/attrs/lowercase-enum';
import { AudienceType } from '@square/dashboard-data/models/squareup/rolodex/group';
import { jsonGet } from '@square/dashboard-utilities/utils/xhr';
import Enum from '@square/dashboard-utilities/utils/enum';

// Keep this in sync with Channel in marketing-email (frontend/dashboard/app/models/marketing-email.js)!
export const Channel = new Enum(['EMAIL', 'FACEBOOK', 'RECEIPT', 'SMS', 'CASH_APP']);
export default EmberDataBaseModel.extend({
  size: attr('number'),
  countOfEmail: attr('number'),
  countOfSms: attr('number'),
  label: attr('string'),
  description: attr('string'),
  definition: attr('string'),
  nature: attr('enum', {
    enumClass: lowercaseEnum(AudienceNatures)
  }),
  presetGroupType: attr('enum', {
    enumClass: lowercaseEnum(AudiencePresetGroupType)
  }),
  staleSize: attr('number'),
  token: attr('string'),
  isUserGenerated: equal('nature', AudienceNatures.ROLODEX),
  isTesting: equal('nature', AudienceNatures.TESTING),
  isSmartGroup: isIn('nature', AudienceType.values),
  isReachable: equal('nature', AudienceNatures.REACHABLE)
}).reopenClass({
  _modelNameForMigration: 'marketing/marketing-audience',
  rootKey: 'audience',
  collectionKey: 'audiences',
  url: '/outreach/api/audiences',
  clearCache(store) {
    store.unloadAll('marketing/marketing-audience');
  },
  getMarketingAudiences(store, {
    channel,
    isCoupon,
    excludeAudiences
  }) {
    // Would use URLSearchParams toString, but that encodes []
    const params = [`channel=${channel}`];
    if (isCoupon) {
      params.push('permissions[]=COUPON');
    }
    if (excludeAudiences) {
      params.push('exclude_audiences=true');
    }
    const queryParams = params.join('&');
    const adapter = store.adapterFor('marketing/marketing-audience');
    const url = `/${adapter.namespace}/${adapter.pathForType()}?${queryParams}`;
    return jsonGet(url).then(response => {
      (response.audiences || []).forEach(audience => {
        store.pushPayload('marketing/marketing-audience', audience);
      });
      return {
        allAudiencesCountOfEmail: response.all_audiences_count_of_email,
        allAudiencesCountOfSms: response.all_audiences_count_of_sms,
        audiences: store.peekAll('marketing/marketing-audience').toArray()
      };
    });
  }
});